<template>
  <el-form ref="trackForm" :model="form" :rules="rules" label-width="0px" @submit.native.prevent="handleSubmit">
    <h3 class="xy-title"><b>运单查询</b></h3>
    <el-form-item label="">
      <el-input
        v-model="form.bills"
        type="textarea"
        :rows="4"
        placeholder="请输入运单单号(最多10个),用回车键分隔"
        @focus="handleFocus"
        @blur="handleBlur"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" native-type="submit" size="mini" icon="el-icon-search" style="margin-top: 10px;">查询</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        language: 'zh',
        bills: '',
      },
      rules: {
        bills: [
          { required: true, message: '请输入运单单号', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    handleFocus(event) {
      if (event.target.value === '请输入运单单号(最多10个),用回车键分隔') {
        event.target.value = '';
      }
    },
    handleBlur(event) {
      if (event.target.value === '') {
        event.target.value = '请输入运单单号(最多10个),用回车键分隔';
      }
    },
    handleSubmit() {
      this.$refs.trackForm.validate((valid) => {
        if (valid) {
            // 跳转到目标页面
            window.open('https://xy56.kingtrans.cn/WebTrack?bills=' + this.form.bills, '_blank');
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.el-form {
  width: 300px;
}
.el-form-item {
  margin-bottom: 20px;
}
.el-button {
  float: right;
}
</style>



// WEBPACK FOOTER //
// xy-track-form.vue?fb7f9fb6